import VueTypes from 'vue-types';

export const BreadcrumbsItem = VueTypes.shape({
    route: VueTypes.string.isRequired,
    title: VueTypes.string.isRequired,
}).isRequired;

export const createBreadcrumbsItem = ({
    route, title
}) => {
    return {
        route: route,
        title: title,
    }
}
